import React from "react";

import Link from "next/link";

import { CSSObject } from "@emotion/react";

import BrickedOffDoorIcon from "@/icons/BrickedOffDoorIcon";
import {
  errorPanelCss,
  errorTitleCss,
  errorBodyCss,
} from "./ErrorMessage.style";

interface ErrorMessageProps {
  headline?: string;
  illustration?: React.ReactNode;
  children?: React.ReactNode;
  __cssFor?: {
    root?: CSSObject;
    headline?: CSSObject;
  };
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  headline = "Error",
  illustration = <BrickedOffDoorIcon />,
  children = (
    <>
      <span>Please contact our </span>
      <Link href="https://support.newsela.com/contact/">help desk</Link>
      <span> for support.</span>
    </>
  ),
  __cssFor = {},
}) => {
  return (
    <div css={[errorPanelCss, __cssFor.root]}>
      {illustration}
      <div>
        <h1 css={[errorTitleCss, __cssFor.headline]}>{headline}</h1>
        <div css={errorBodyCss}>{children}</div>
      </div>
    </div>
  );
};

export default ErrorMessage;
